// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__15x-2","fileBtn":"File_fileBtn__3rF74","closeBtn":"File_closeBtn__2tmSL","fileSelected":"File_fileSelected__185-4","disabled":"File_disabled__1-c_Q"};